import React, { memo, useMemo } from "react";
import { MetadataItem } from "../types/metadata";
import { CATEGORY_ACCENT_COLORS, DEFAULT_CATEGORY_ACCENT_COLOR } from "../config/constants";
import Text from "./Text";
interface ItemCardProps {
  item: MetadataItem;
  language: string;
  onSelect?: (item: MetadataItem) => void;
}

const getCategoryColor = (category: string | undefined): string => {
  if (!category) return DEFAULT_CATEGORY_ACCENT_COLOR;

  const categoryMapping = CATEGORY_ACCENT_COLORS.find((mapping) =>
    mapping.categories.includes(category as never),
  );

  return categoryMapping?.color || DEFAULT_CATEGORY_ACCENT_COLOR;
};

const ItemCardInner: React.FC<ItemCardProps> = ({ item, language, onSelect }) => {
  const borderColor = useMemo(() => getCategoryColor(item.category), [item.category]);

  return (
    <button
      type="button"
      data-id={item.id}
      className="relative flex w-full flex-col justify-center py-4 pl-5 pr-2 text-left bg-white border-b border-Border min-h-[6rem] min-w-[8rem] hover:bg-Background active:bg-Border transition-colors duration-150 cursor-pointer"
      onClick={() => onSelect && onSelect(item)}
    >
      {/* カテゴリカラーの左ボーダー */}
      <span
        aria-hidden="true"
        className="absolute left-0 top-4 bottom-4 w-[6px] rounded-full"
        style={{ backgroundColor: borderColor }}
      />
      {/* name_japanese を表示 */}
      <Text as="span" variant="body/l" weight="bold" className="block">
        {language === "ja"
          ? item.name_japanese
          : language === "en"
            ? item.name_english
            : item.name_english}
      </Text>
      {/* faculty_name_ja を表示 */}
      {item.faculty_name_ja && (
        <Text as="span" variant="body/m" weight="regular" className="block text-TextPrimary">
          {language === "ja"
            ? item.faculty_name_ja
            : language === "en"
              ? item.faculty_name_en
              : item.faculty_name_en}
        </Text>
      )}
    </button>
  );
};

export const ItemCard = memo(ItemCardInner);
export default ItemCard;
